
const { NIMBUS_DATA_TYPES } = require('../nimbus-data-types');

module.exports = {
  displayName: 'Material Header Path',
  description: 'Example: Marico/material-sample.xlsx',
  sortOrder: 1,
  name: 'materialHeaderPath',
  documentKey: 'material_header_path',
  values: {
    material_header_path: {
      dataType: NIMBUS_DATA_TYPES.STRING,
      defaultValue: '',
      displayName: 'Material Header Path',
      documentKey: 'material_header_path',
    },
  },
};
